import { IFormField } from '../IForm.types';
import { ItemForm } from './ItemForm';

export class TextForm extends ItemForm {
  override label = 'Label';
  override input = false;
  tag = 'div';
  content = 'Testo semplice da visualizzare';
  type = 'htmlelement';
  override hideLabel = true;

  constructor(field: IFormField) {
    super(field);
    this.customClass = 'mb-2';
    this.content = field.description;
  }
}
